import type { IValidationResult, IValidatorParams, IValidationError } from "@edaz/services/baseValidationService";

type DynamicBoundary = (entity: any) => number | undefined;

export interface RangeOptions {
  min?: number | DynamicBoundary;
  max?: number | DynamicBoundary;
  allowEqual?: boolean;
  optional?: boolean;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export default function range(value: any, options: RangeOptions, params?: IValidatorParams): IValidationResult {
  let isValid = true;
  let errors: IValidationError | undefined;
  const min = options.min && typeof options.min === "function" ? options.min(params?.entity) : options.min;
  const max = options.max && typeof options.max === "function" ? options.max(params?.entity) : options.max;
  const allowEqual = options.allowEqual ?? true;

  if (options.optional && !value) {
    return {
      isValid: true,
    };
  }

  if (value !== undefined || value !== "") {
    if (min !== undefined && allowEqual && value < min) {
      isValid = false;
      errors = {
        constraints: {
          min: min.toString(),
        },
        params: [min.toString()],
      };
    } else if (min !== undefined && !allowEqual && value <= min) {
      isValid = false;
      errors = {
        constraints: {
          minEqual: min.toString(),
        },
        params: [min.toString()],
      };
    }

    if (max !== undefined && allowEqual && value > max) {
      isValid = false;
      errors = {
        constraints: {
          max: max.toString(),
        },
        params: [max.toString()],
      };
    } else if (max !== undefined && !allowEqual && value >= max) {
      isValid = false;
      errors = {
        constraints: {
          maxEqual: max.toString(),
        },
        params: [max.toString()],
      };
    }
  }

  return {
    isValid,
    errors,
  };
}
